<template>
  <div>
    <form id="frm-cancelation"
          ref="frm-cancelation"
          accept-charset="UTF-8"
          class="card"
          method="GET"
          onsubmit="return false">
      
      <div class="card-header">
        <h1 class="card-title mb-0">Cancelar Protocolo</h1>
      </div>
      <div class="card-body">
        <p class="mb-4">Ingrese los datos solicitados para poder cancelar el protocolo.</p>
        <file-input input-id="file"
                    input-name="file"
                    ref="fileInput"
                    input-place-holder="Archivo del comprobante"
                    label-text="Comprobante de cancelación:"
                    :required="true"></file-input>
        
        <div class="form-group">
          <label class="d-block font-weight-normal"
                 for="observations">Comentarios:
            <abbr style="text-decoration: none;"
                  title="Campo obligatorio">*</abbr>
          </label>
          <textarea id="observations"
                    v-model="observations"
                    class="form-control"
                    name="observations"
                    ref="observaciones"
                    placeholder="Ingrese sus observaciones..."
                    rows="3"></textarea>
        </div>
      </div>
      <div class="card-footer d-flex py-2 px-2">
        <button class="btn btn-lg btn-primary mr-2"
                type="submit">Continuar
        </button>
      </div>
    </form>
    
    <portal to="modals">
      <ok-cancel-dialog id="accept-cancel-modal"
                        ref="accept-cancel-modal"
                        :ok-button-text="'Confirmar'"
                        content="<p>¿Esta seguro de cancelar el protocolo?</p>"
                        title="Confirmar cancelación"
                        @ok-button-pressed="cancelProtocolByCommittee"></ok-cancel-dialog>
    </portal>
  </div>
</template>

<script>
  import 'jquery-validation'
  import OkCancelDialog from '../../ui/OkCancelDialog'
  import { AlertManager } from '../../utils/AlertManager'
  import { mapActions } from 'vuex'
  import autosize from 'autosize'
  import FileInput from '../../../components/ui/FileInput'
  
  export default {
    name: 'CancelProtocol',
    components: {
      OkCancelDialog,
      FileInput,
    },
    data() {
      return {
        observations: '',
      }
    },
    props: {
      protocol: Object,
      committee: Object,
    },
    methods: {
      ...mapActions({
        cancelProtocol: 'committees/cancelProtocol',
      }),
      
      async cancelProtocolByCommittee() {
        this.$refs['accept-cancel-modal'].sending = true

        const file = this.$refs.fileInput.$refs.file.files[0]
        
        const formData = new FormData()
        formData.append('protocol_id', this.protocol.id)
        formData.append('committee_id', this.committee.id)
        formData.append('observations', this.observations)
        formData.append('file', file)
        
        const response = await this.cancelProtocol(formData)
        
        AlertManager.success(response.message)
        
        this.$refs['accept-cancel-modal'].sending = false
        this.$refs['accept-cancel-modal'].close()
        
        location.reload()
      },
    },
    mounted() {
      autosize(this.$refs.observaciones)
      
      $('#frm-cancelation').validate({
        highlight: function(element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function(element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function(label, element) {
          label.addClass('invalid-feedback')
          label.insertAfter(element)
        },
        rules: {
          file: {
            required: true,
          },
          observations: {
            required: true,
          },
        },
        messages: {
          file: {
            required: 'Este campo es requerido.',
          },
          observations: {
            required: 'Este campo es requerido.',
          },
        },
        submitHandler(form) {
          $('#accept-cancel-modal').modal('show')
        },
      })
    },
  }
</script>
